import { Box, ProgressCircle } from "@chakra-ui/react";
import { ReactNode, useEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "react-oidc-context";
import { RoutePath } from "./config";
import { getSelectedInstanceId } from "./authStore";

const Spinner = () => (
    <ProgressCircle.Root value={null} size="lg" transitionDuration={"200"} mt={"20vh"} color="orange" css={{ "--thickness": "2px" }} />
);

const ProtectedRoute = ({ children }: { children: ReactNode }): JSX.Element => {
    const auth = useAuth();
    const location = useLocation();

    // Not signed in → bounce to Keycloak (code+PKCE).
    useEffect(() => {
        if (!auth.isLoading && !auth.isAuthenticated && !auth.activeNavigator && !auth.error) {
            void auth.signinRedirect();
        }
    }, [auth.isLoading, auth.isAuthenticated, auth.activeNavigator, auth.error]);

    if (auth.isLoading || !auth.isAuthenticated) {
        return <Box transition={"all 0.5s ease"} flex={1} display="flex" flexDir="column"><Spinner /></Box>;
    }

    // Signed in but no instance chosen → pick one first.
    if (getSelectedInstanceId() == null && location.pathname !== RoutePath.SelectInstance) {
        return <Navigate to={RoutePath.SelectInstance} replace />;
    }

    return (
        <Box transition={"all 0.5s ease"} flex={1} display="flex" flexDir="column">
            {children}
        </Box>
    );
};

export default ProtectedRoute;
